import { render } from "./DataImportWidget.vue?vue&type=template&id=abbff5f2&scoped=true"
import script from "./DataImportWidget.vue?vue&type=script&lang=ts"
export * from "./DataImportWidget.vue?vue&type=script&lang=ts"

import "./DataImportWidget.vue?vue&type=style&index=0&id=abbff5f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-abbff5f2"

export default script